import { arrayOf, object, shape, string } from 'prop-types';
import React from 'react';
import AmpTeaser from 'components/AmpTeaser';
import AmpAd from 'components/AmpAd';
import styles from './styles';

// This is a VERY basic spread implementation! If we want to use it beyond the
// below post recirc it will likely require additional work.

function AmpSpread({ data, items }) {
  // The teaser count (i.e. not ads...) is required for styling
  const count = items ? items.filter(i => i.type === 'teaser').length : 0;

  if (!(items && items.length)) {
    return null;
  }

  return (
    <div className={`AmpSpread AmpSpread--${count}`}>
      <header className="AmpSpread__title">
        <h1 dangerouslySetInnerHTML={{ __html: data.title }} />
      </header>
      <div className="AmpSpread__items">
        {items.map(item => {
          switch (item.type) {
            // Note: This spread only supports teasers and ads
            case 'teaser':
              return (
                <div
                  key={item.id}
                  className="AmpSpread__item AmpSpread__item--teaser"
                >
                  <a href={item.data.url}>
                    <AmpTeaser {...item.data} />
                  </a>
                </div>
              );
            case 'ad':
              return (
                <div
                  className="AmpSpread__item AmpSpread__item--ad"
                  key={item.id}
                >
                  <AmpAd {...item.data} />
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

AmpSpread.defaultProps = {
  data: {},
  items: []
};

AmpSpread.propTypes = {
  data: shape({
    title: string
  }),
  items: arrayOf(
    shape({
      id: string,
      type: string,
      data: object
    })
  )
};

export default AmpSpread;
